/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./niota.vue?vue&type=template&id=0b24d23d&scoped=true&"
import script from "./niota.vue?vue&type=script&lang=js&"
export * from "./niota.vue?vue&type=script&lang=js&"
import style0 from "./niota.vue?vue&type=style&index=0&id=0b24d23d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24d23d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VAutocomplete,VCol,VDataTable,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})
